var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['tag', { tag__active_free: _vm.free } , { tag__active: _vm.active }]},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }